import request from "@/request";

const part_url = "/train/pool/";

function getByUser() {
  let url = part_url + "getByUser";
  return request.get(url);
}

function addPoolInfo(data) {
  let url = part_url + "addPoolInfo";
  return request.post(url, {}, data);
}

function updatePoolInfo(data) {
  let url = part_url + "updatePoolInfo";
  return request.post(url, {}, data);
}

export default {
  getByUser,
  addPoolInfo,
  updatePoolInfo,
};



// WEBPACK FOOTER //
// ./src/api/pool.js